module.exports = __webpack_public_path__ + "static/media/home.fb29f466.svg";